import type { FileName } from "@pdfking/structs"

/** A browser's name for a file, as the name we will know it by.
 *
 * The only thing done to it is NFC: macOS spells an accented name decomposed
 * ("e" + U+0301) and every other platform composes it, and the two are the
 * same name to a reader and two different keys to a record. Everything that
 * later matches a file by name — an upload against what a storage wrote back,
 * an imposition row against the file it points at — matches on this, so it has
 * to be one spelling, and NFC is the one a server (and a url, and a header)
 * will also have chosen. */
export const CreateFileName = (name: string): FileName => name.normalize("NFC") as FileName
